import { NgModule, ModuleWithProviders, SkipSelf, Optional, NgModuleRef, InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiConfigManager, ApiConfigOptions, ModuleSourceInfo } from '@sg/api/base-api-lib';
import { CompaniesApiClient } from './services';
import { CompaniesApiConfig } from './api-config';

declare module '../../../base-api-lib/src/lib/api-config-manager' {
  interface ApiConfigOptionsStore {
    companiesApiConfig?: ApiConfigOptions;
  }
  interface ApiConfigManager {
    companiesApiConfig: CompaniesApiConfig;
  }
}

export const CONFIG_FACTORY_TOKEN = new InjectionToken('CompaniesApiModule Config Factory');

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [CompaniesApiClient],
})
export class CompaniesApiModule {
  public static forRoot(
    configFactory?: (cfgMgr?: ApiConfigManager) => CompaniesApiConfig
  ): ModuleWithProviders<CompaniesApiModule> {
    return {
      ngModule: CompaniesApiModule,
      providers: [{ provide: CONFIG_FACTORY_TOKEN, useValue: configFactory }],
    };
  }

  constructor(
    cfgMgr: ApiConfigManager,
    moduleRef: NgModuleRef<any>,
    @Optional() @SkipSelf() parentModule: CompaniesApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CompaniesApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }

    const configFactory: (cfgMgr?: ApiConfigManager) => CompaniesApiConfig =
      moduleRef.injector.get<any>(CONFIG_FACTORY_TOKEN);
    const config = configFactory
      ? configFactory(cfgMgr)
      : new CompaniesApiConfig(cfgMgr.withBase(cfgMgr.getRawConfig('companiesApiConfig')));
    cfgMgr.addApiConfig('companiesApiConfig', config);
  }
}
